import { getHeaders } from "../utils";


export const APIGetProjectsByFilter = async (companyId) => {
    try {


        var headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);
            headers.append("Content-Type", "application/json");

        if(companyId !== null) {

            // filter
            var filters = { companyId: companyId};

            var requestOptions = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(filters),
                redirect: 'follow'
            };

            const response = await fetch(((process.env.REACT_APP_MODE_HF === 'PROD') ? process.env.REACT_APP_API_URL_PRODUCTION_HF : process.env.REACT_APP_API_URL_DEVELOPMENT_HF )+"/search/projects", requestOptions)

            const responseObject = await response.json();

            return responseObject.rows;
        }

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}




export const APIGetProjectById = async (id) => {
    try {

        var headers = getHeaders(process.env.REACT_APP_API_EXTERNAL_TOKEN);
            headers.append("Content-Type", "application/json");

        if(id !== null) {


            var requestOptions = {
                method: 'GET',
                headers: headers,
                redirect: 'follow'
            };

            const response = await fetch(((process.env.REACT_APP_MODE_HF === 'PROD') ? process.env.REACT_APP_API_URL_PRODUCTION_HF : process.env.REACT_APP_API_URL_DEVELOPMENT_HF )+"/projects/"+id, requestOptions)
            const responseObject = await response.json();
            return responseObject?.[0];
        }

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}



export const APIGetProjectDraftsById = async (id) => {
    try {

        var headers = new Headers();
            headers.append("Content-Type", "application/json");

        if(id !== null) {

            var raw = JSON.stringify(
                {
                    schema: "projectsDrafts",
                    condition: [
                        {
                            type: "eq",
                            field: "projectsId",
                            values: [
                                id
                            ]
                        }
                    ]
                });

            var requestOptions = {
                method: 'POST',
                headers: headers,
                body: raw,
                redirect: 'follow'
            };

            const response = await fetch(((process.env.REACT_APP_MODE_HF === 'PROD') ? process.env.REACT_APP_API_URL_PRODUCTION_HF : process.env.REACT_APP_API_URL_DEVELOPMENT_HF )+"/search", requestOptions)
            const responseObject = await response.json();

            return responseObject.rows;
        }

    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

